// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 600px) {
    .main-base {
        height: 100vh;
        width: 100.5%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .image-base {
        height: 60%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url(https://minimals.cc/assets/illustrations/illustration_dashboard.png);
        background-repeat: no-repeat;
        background-size: 80%;
        background-position: center;
        background-color: var(--ColorSecondary);
    }

    .login-base {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .login-base-box {
        background-color: whitesmoke;
        height: 80%;
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
        justify-content: space-evenly;
    }

    .login-base-box-children {
        height: 50%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }

    .login-base-box-children-text {
        height: 25%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }

    .login-base-box-children-logo {
        height: 20%;
        width: 100%;
    }
}

@media only screen and (min-width: 600px) {
    .main-base {
        height: 100vh;
        width: 100%;
        display: flex;
    }

    .image-base {
        height: 100%;
        width: 80%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url(https://minimals.cc/assets/illustrations/illustration_dashboard.png);
        background-repeat: no-repeat;
        background-size: 60%;
        background-position: center;
        background-color: var(--ColorSecondary);
    }

    .login-base {
        height: 100%;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .login-base-box {
        background-color: whitesmoke;
        height: 80%;
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
        justify-content: space-evenly;
    }

    .login-base-box-children {
        height: 35%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }

    .login-base-box-children-text {
        height: 25%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }

    .login-base-box-children-logo {
        height: 20%;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/ManagerCondominium/ManagerCondominium.css"],"names":[],"mappings":"AAAA;IACI;QACI,aAAa;QACb,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,0FAA0F;QAC1F,4BAA4B;QAC5B,oBAAoB;QACpB,2BAA2B;QAC3B,uCAAuC;IAC3C;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;QAC5B,WAAW;QACX,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,yCAAyC;QACzC,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;QACb,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,0FAA0F;QAC1F,4BAA4B;QAC5B,oBAAoB;QACpB,2BAA2B;QAC3B,uCAAuC;IAC3C;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;QAC5B,WAAW;QACX,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,yCAAyC;QACzC,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;AACJ","sourcesContent":["@media only screen and (max-width: 600px) {\n    .main-base {\n        height: 100vh;\n        width: 100.5%;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n    }\n\n    .image-base {\n        height: 60%;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-image: url(https://minimals.cc/assets/illustrations/illustration_dashboard.png);\n        background-repeat: no-repeat;\n        background-size: 80%;\n        background-position: center;\n        background-color: var(--ColorSecondary);\n    }\n\n    .login-base {\n        height: 100%;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .login-base-box {\n        background-color: whitesmoke;\n        height: 80%;\n        width: 80%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-radius: 10px;\n        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n        justify-content: space-evenly;\n    }\n\n    .login-base-box-children {\n        height: 50%;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-evenly;\n        align-items: center;\n    }\n\n    .login-base-box-children-text {\n        height: 25%;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-evenly;\n        align-items: center;\n    }\n\n    .login-base-box-children-logo {\n        height: 20%;\n        width: 100%;\n    }\n}\n\n@media only screen and (min-width: 600px) {\n    .main-base {\n        height: 100vh;\n        width: 100%;\n        display: flex;\n    }\n\n    .image-base {\n        height: 100%;\n        width: 80%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-image: url(https://minimals.cc/assets/illustrations/illustration_dashboard.png);\n        background-repeat: no-repeat;\n        background-size: 60%;\n        background-position: center;\n        background-color: var(--ColorSecondary);\n    }\n\n    .login-base {\n        height: 100%;\n        width: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .login-base-box {\n        background-color: whitesmoke;\n        height: 80%;\n        width: 80%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-radius: 10px;\n        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n        justify-content: space-evenly;\n    }\n\n    .login-base-box-children {\n        height: 35%;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-evenly;\n        align-items: center;\n    }\n\n    .login-base-box-children-text {\n        height: 25%;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-evenly;\n        align-items: center;\n    }\n\n    .login-base-box-children-logo {\n        height: 20%;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
